import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const FertilizerRecommendationForm = () => {
  const [formData, setFormData] = useState({
    cropName: "",
    ph: "",
    nitrogen: "",
    phosphorus: "",
    potassium: "",
    temperature: "",
    humidity: "",
    windspeed: "",
  });

  const tamilNaduDistricts = [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul",
    "Erode", "Kallakurichi", "Kanchipuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai",
    "Nagapattinam", "Namakkal", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet",
    "Salem", "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli",
    "Tirunelveli", "Tirupattur", "Tiruppur", "Vellore", "Viluppuram", "Virudhunagar"
  ];

  const cropOptions = [
    "rice", "wheat", "maize", "cotton", "sugarcane", "barley", "millet", "groundnut",
    "soybean", "sunflower", "chickpea", "lentil", "banana", "mango", "tomato", "brinjal",
    "potato", "onion", "carrot", "cabbage", "cauliflower", "beans", "peas", "spinach",
    "mustard", "turmeric", "ginger", "pepper", "cardamom", "coffee"
  ];

  const [city, setCity] = useState("");
  const [recommendations, setRecommendations] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (city.length > 2) {
      axios.get(`http://localhost:5001/api/weather?city=${city}`)
        .then(res => {
          setFormData(prev => ({
            ...prev,
            temperature: res.data.temperature.toString(),
            humidity: res.data.humidity.toString(),
            windspeed: res.data.windspeed.toString()
          }));
        })
        .catch(err => console.error("Weather API Error:", err));
    }
  }, [city]);

  useEffect(() => {
    setRecommendations([]);
  }, [formData]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setRecommendations([]);
    try {
      const res = await axios.post("http://localhost:5001/fertilizer", {
        ...formData,
        ph: parseFloat(formData.ph),
        nitrogen: parseFloat(formData.nitrogen),
        phosphorus: parseFloat(formData.phosphorus),
        potassium: parseFloat(formData.potassium),
        temperature: parseFloat(formData.temperature),
        humidity: parseFloat(formData.humidity),
        windspeed: parseFloat(formData.windspeed),
      });
      setRecommendations(res.data.recommendedFertilizers);
      setShowModal(true);
    } catch (err) {
      console.error("Error Submitting Form:", err);
      setError("Failed to fetch recommendations. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <div style={{ width: "250px", backgroundColor: "#2e7d32", color: "white", padding: "30px 20px" }}>
        <h2 style={{ textAlign: "center" }}>Smart Farming</h2>
        <nav style={{ display: "flex", flexDirection: "column", gap: "35px", paddingLeft: '30px' }}>
          {["HOME", "CROP", "FERTILIZER", "WEATHER", "LEAF COLOR CHART"].map((item) => {
            const path = item === "LEAF COLOR CHART" ? "/lcc" : `/${item.toLowerCase()}`;
            return (
              <Link key={item} to={path} style={{ color: "white", textDecoration: "none" }}>
                {item}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Main Form Area */}
      <div style={{
        flex: 1,
        backgroundColor: '#f8f9fa',
        height: '100vh',
        overflowY: 'auto',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <h2 style={{
          backgroundColor: "#2e7d32",
          margin: 0,
          color: "white",
          padding: "15px",
          width: "100%",
          textAlign: "center"
        }}>
          FERTILIZER RECOMMENDATION
        </h2>

        <form onSubmit={handleSubmit} style={{
          backgroundColor: "white",
          marginTop: '35px',
          padding: "20px",
          borderRadius: "10px",
          width: "80%",
          maxWidth: "600px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)"
        }}>
          {/* District Dropdown */}
          <div style={{
            backgroundColor: "white",
            padding: "15px",
            borderRadius: "10px",
            marginBottom: "15px"
          }}>
            <div style={{ marginBottom: "10px" }}>
              <label style={{ fontWeight: "bold" }}>Select District (Tamil Nadu):</label>
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  marginTop: "5px"
                }}
              >
                <option value="">Select District</option>
                {tamilNaduDistricts.map((district) => (
                  <option key={district} value={district}>{district}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Crop Dropdown */}
          <div style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "bold" }}>CROP NAME:</label>
            <select
              name="cropName"
              value={formData.cropName}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ccc"
              }}
            >
              <option value="">Select Crop</option>
              {cropOptions.map((crop) => (
                <option key={crop} value={crop}>
                  {crop.charAt(0).toUpperCase() + crop.slice(1)}
                </option>
              ))}
            </select>
          </div>

          {/* Remaining Inputs */}
          {["ph", "nitrogen", "phosphorus", "potassium"].map((field) => (
            <div key={field} style={{ marginBottom: "10px" }}>
              <label style={{ fontWeight: "bold" }}>{field.toUpperCase()}:</label>
              <input
                type="text"
                name={field}
                value={formData[field]}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid #ccc"
                }}
              />
            </div>
          ))}

          {/* Read-only Weather Inputs */}
          {["temperature", "humidity", "windspeed"].map((field) => (
            <div key={field} style={{ marginBottom: "10px" }}>
              <label style={{ fontWeight: "bold" }}>{field.toUpperCase()}:</label>
              <input
                type="number"
                name={field}
                value={formData[field]}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f0f0f0"
                }}
              />
            </div>
          ))}

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#2e7d32",
              color: "white",
              borderRadius: "5px",
              border: "none"
            }}
          >
            {loading ? "Fetching..." : "Submit"}
          </button>
        </form>

        {/* Error Message */}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {/* Popup Modal */}
        {showModal && (
          <div style={{
            position: "fixed",
            top: 0, left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000
          }}>
            <div style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "500px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              textAlign: "center",
              position: "relative"
            }}>
              <h3>Recommended Fertilizers</h3>
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                {recommendations.map((rec, index) => (
                  <li key={index}>{rec}</li>
                ))}
              </ul>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  marginTop: "20px",
                  padding: "10px 20px",
                  backgroundColor: "#2e7d32",
                  color: "white",
                  border: "none",
                  borderRadius: "5px"
                }}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FertilizerRecommendationForm;
